import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LeurreSearch } from '../../../../../../../data/commission/models/leurre-search.model';
import { Controle } from '../../../../../../../data/declaration/models/controle.model';
import { JuresService } from '../../../../../../../data/commission/services/jures/jures.service';
import { EvaluationJuresService } from '../../../../../../../data/commission/services/evaluation-jures/evaluation-jures.service';
import { CriteresEvaluationJure } from '../../../../../../../data/commission/models/criteres-evaluation-jure.model';
import { JureCommission } from '../../../../../../../data/commission/models/jure-commission.model';
import { EvaluationJure } from '../../../../../../../data/commission/models/evaluation-jure.model';
import { forkJoin } from 'rxjs';
import { LoaderService } from '../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-evaluation-jure',
    templateUrl: './evaluation-jure.component.html',
    styleUrls: ['./evaluation-jure.component.scss'],
    standalone: false
})
export class EvaluationJureComponent implements OnInit {
    /**
     * Liste des leurres
     */
    @Input() leurres: LeurreSearch[] = [];

    /**
     * Controle
     */
    @Input() controle: Controle;

    /**
     * Id de l'organisme
     */
    @Input() idOrganisme: number;

    /**
     * Current leurre
     */
    currentLeurre: LeurreSearch;

    /**
     * Liste des jurés
     */
    jures: JureCommission[] = [];

    /**
     * Liste des critères d'évaluation jure
     */
    critereEvaluationJure: CriteresEvaluationJure[] = [];

    /**
     * Evaluations des jurés
     */
    evaluations: EvaluationJure[] = [];

    /**
     * Original évaluation des jurés
     */
    originalEvaluations: EvaluationJure[] = [];

    /**
     * True si résultat est disponible
     */
    isResult = false;

    constructor(
        public readonly modal: NgbActiveModal,
        private readonly modalService: NgbModal,
        private readonly juresService: JuresService,
        private readonly loaderService: LoaderService,
        private readonly evaluationJuresService: EvaluationJuresService
    ) {}

    /**
     * On init component
     */
    ngOnInit() {
        this.currentLeurre = this.leurres.find(leurre => leurre.idLeurre === this.controle.idLeurre);

        forkJoin([
            this.juresService.getJureByCommission(this.idOrganisme, this.currentLeurre.numeroCommission),
            this.evaluationJuresService.getCriteresEvaluationJures(this.idOrganisme),
            this.evaluationJuresService.getEvaluationsJure(null, null, this.controle.idLeurre)
        ]).subscribe(([jures, critereEvaluationJure, evaluations]) => {
            this.isResult = true;
            this.jures = jures;
            this.critereEvaluationJure = critereEvaluationJure;
            this.evaluations = evaluations;
            if (this.evaluations.length === 0) {
                this.initializeEvaluation();
            }
            this.originalEvaluations = this.evaluations.map(evaluation => ({ ...evaluation }));
        });
    }

    /**
     * Initialise les évaluations des jurés
     */
    initializeEvaluation() {
        for (const jure of this.jures) {
            for (const critere of this.critereEvaluationJure) {
                this.evaluations.push({
                    id: null,
                    idJure: jure.idJure,
                    idCritereEvaluation: critere.id,
                    idLeurre: this.controle.idLeurre,
                    valeurOui: null,
                    dateCommission: null,
                    typeLeurre: null
                });
            }
        }
    }

    /**
     * Evaluation des jurés
     * @param idJure - L'id du juré
     * @param idCritere - L'id du critère
     */
    getEvaluation(idJure: number, idCritere: number): EvaluationJure {
        return this.evaluations.find(e => e.idJure === idJure && e.idCritereEvaluation === idCritere);
    }

    /**
     * Ferme la modale
     */
    onClose() {
        this.modal.close();
    }

    /**
     * Validation des évaluations
     */
    onValidateEvaluation() {
        const hasAlreadyEvaluation = this.originalEvaluations.every(evaluation => evaluation.valeurOui !== null);
        if (hasAlreadyEvaluation) {
            this.evaluationJuresService
                .updateEvaluationJure(this.evaluations)
                .pipe(this.loaderService.operator())
                .subscribe(() => {
                    this.onClose();
                });
        } else {
            this.evaluationJuresService
                .createEvaluationJure(this.evaluations)
                .pipe(this.loaderService.operator())
                .subscribe(() => {
                    this.onClose();
                });
        }
    }

    /**
     * Valider l'évaluation si une réponse a été apportée pour chaque juré
     */
    canValidate(): boolean {
        return this.evaluations.every(evaluation => evaluation.valeurOui !== null) && this.hasChanged();
    }

    /**
     * Les évaluations déjà existantes ont été modifiées
     */
    hasChanged(): boolean {
        return this.evaluations.some((currentEval, index) => {
            const original = this.originalEvaluations[index];
            return currentEval.valeurOui !== original.valeurOui;
        });
    }
}
